import { UniverseReference, User } from '@front/common/src/types/commons';
import { isWellnessReference } from '@front/common/src/utils/universes';

export const hasPaidMembership = (user?: User) => user?.membership?.origin === 'paid';
export const hasRecurrentMembership = (user?: User) => user?.membership?.origin === 'recurrent';

export const hasActiveMembership = (user?: User) => user?.membership?.status === 'active';
export const hasRequestedMembership = (user?: User) => user?.membership?.status === 'requested';
export const hasTrialMembership = (user?: User) => user?.membership?.status === 'trial';

export const hasMembership = (user?: User) => hasPaidMembership(user) || hasRecurrentMembership(user);

export const isPaidMembershipWithCurrentFreeTrial = (user?: User) => {
  if (!user || !user.membership) return false;

  return hasPaidMembership(user) && hasTrialMembership(user);
};

export const isRequestedPaidMembership = (user?: User) => {
  if (!user || !user.membership) return false;

  return hasPaidMembership(user) && hasRequestedMembership(user);
};

export const isRequestedPaidMembershipWithoutPreviousFreeTrial = (user?: User) => {
  if (!user) return false;

  const { membership_trial_used: hasPreviousFreeTrial } = user;

  return isRequestedPaidMembership(user) && !hasPreviousFreeTrial;
};

export const isActivePaidMembership = (user?: User) => {
  if (!user || !user.membership) return false;

  return hasPaidMembership(user) && hasActiveMembership(user);
};

type IsUserWantingAnotherFreeTrialAlthoughPreviousTrialParams = {
  user: User;
  isRequestingMembership: boolean;
  universeReference: UniverseReference;
  isCleaningSpot?: boolean;
};

export const isUserWantingAnotherFreeTrialAlthoughPreviousTrial = ({
  user,
  isRequestingMembership,
  universeReference,
  isCleaningSpot,
}: IsUserWantingAnotherFreeTrialAlthoughPreviousTrialParams) => {
  if (hasMembership(user)) return false;

  const { membership_trial_used: hasPreviousTrial } = user;

  const isPaidMembershipRequest = isWellnessReference(universeReference) || isCleaningSpot;

  return hasPreviousTrial && isRequestingMembership && isPaidMembershipRequest;
};
